<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="foodMajorKinds"
    :title="`${$t('title.selectfoodmajorkind')}`"
    idProperty="FoodMajorKindId"
    nameProperty="FoodMajorKindName"
    allSelectId="foodMajorKindAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="FoodMajorKindNumber"
    :defaultItems="defaultItems"
    viewName="FoodMajorKindSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      foodMajorKinds: [],
      columns: [
        {
          name: "FoodMajorKindNumber",
        },
        {
          name: "FoodMajorKindName",
        },
      ],
      id: "foodMajorKindSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      const vm = this;
      this.$api.foodMajorKinds.getPages(dTO).then((data) => {
        vm.foodMajorKinds = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
